import { removeWhitespace } from "utils/removeWhitespace";

export type DateProps = {
  day: number;
  month: number;
  year: number;
};

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const convertDate = (dateString: string): Date => {
  // dateString ex: "YYYY-MM-DD"
  const [year, month, day] = dateString.split("-");
  const dateObject = new Date(Number(year), Number(month) - 1, Number(day));
  return dateObject;
};

export const formatDateString = ({ day, month, year }: DateProps) => {
  if (!day || !year || !month) {
    return;
  }
  const m = `${month}`;
  const d = `${day}`;
  return `${year}/${m.padStart(2, "0")}/${d.padStart(2, "0")}`;
};

export const formatTimeWithTimezoneOffset = (
  timestamp: string,
  timeZone?: string,
) => {
  if (!timestamp) {
    return "";
  }
  const time = new Date(timestamp);
  return new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: true,
    minute: "2-digit",
    timeZone,
  })
    .format(time)
    .toLowerCase()
    .replace(" ", "");
};

export const getDateTitle = (date: Date) => {
  const dateString = date.toDateString();
  const [weekDay, month, day] = dateString.split(" ");
  let title;
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  if (dateString === today.toDateString()) {
    title = "Today";
  } else {
    title = dateString === tomorrow.toDateString() ? "Tomorrow" : weekDay;
  }
  return { day, month, title, weekDay };
};

export const getMonthDayLength = (month: number) => {
  if (months[month - 1] === "Feb") {
    return 29;
  }
  if (["Sep", "Apr", "Jun", "Nov"].includes(months[month - 1])) {
    return 30;
  }
  return 31;
};

export const parseMonthDayYear = (str: string) => {
  return str.split("/").map((x) => Number(x));
};

export const parseMonthYear = (
  str: string,
): { month: string; year: string } | undefined => {
  const trimmed = removeWhitespace(str).trim();
  const monthYearRegex = /\d\d\/\d\d/;
  if (!monthYearRegex.test(trimmed)) {
    return undefined;
  }
  const [month, year] = trimmed.split("/");
  return { month, year };
};
